import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { Logger } from "../shared/helpers/logger";
import { MessageService } from "../shared/services/message.service";
import { StorageService } from "../shared/services/storage.service";
import { AuthService } from "./auth.service";
import { SettingsService } from "../shared/services/settings.service";

@Injectable({
  providedIn: "root",
})
export class IsAuthenticatedGuard implements CanActivate {
  constructor(
    private messageService: MessageService,
    private authService: AuthService,
    private router: Router,
    private storageService: StorageService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.isAuthenticated().pipe(map(isAuthenticated => {
      if (isAuthenticated) {
        return true;
      }

      this.router.navigateByUrl("/login");
      return false;
    }));
  }
}

@Injectable({
  providedIn: "root",
})
export class IsModuleInstalledGuard implements CanActivate {
  constructor(private settingsService: SettingsService) { }

  canActivate(childRoute: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkModule(childRoute);
  }

  private checkModule(route: ActivatedRouteSnapshot):boolean {
    let hasModuleInstalled = false;
    const checkRouteParam = route.queryParamMap.get('module');
    const checkModule = this.settingsService.hasModule(checkRouteParam);

    if (checkModule) {
      hasModuleInstalled = true;
    }
    else {
      hasModuleInstalled = false;
    }

    return hasModuleInstalled;
  }
}
